<template>
    <div class="activity-card__info banner-mode">
        <div class="title-block">
            <div class="title">
                <InfoIcon />{{ $t("Informations") }}
            </div>
            <div class="icons-container">
                <div id="tooltip-links" @click="$emit('openLinks')" class="show-details-icon">
                    <UrlIcon />
                </div>
                <sys-tooltip target="tooltip-links" triggers="hover blur" placement="top" boundary-padding="0"
                    text="Links" />

                <button type="button" class="attachments-button" :aria-label="$t('ViewAttachments')" :title="$t('ViewAttachments')" @click="$emit('openAttachments')">
                    <feather-icon icon="PaperclipIcon" size="18" />
                </button>
                <div id="tooltip-info-order" @click="$emit('openOrderInfo')" class="show-details-icon">
                    <ShowDetailsIcon />
                </div>
                <sys-tooltip target="tooltip-info-order" triggers="hover blur" placement="top" boundary-padding="0"
                    :text="$t('ShowDetails')" />
            </div>
        </div>
        <div class="info-block">
            <div class="data-point">
                <div class="label">Prod</div>
                <div class="value">{{ infos.prod }}%</div>
            </div>
            <div class="data-point">
                <div class="label">Perf</div>
                <div class="value">{{ infos.perf == null ? "-" : `${infos.perf}%` }}</div>
            </div>
            <div class="data-point">
                <div class="label">{{ $t("QTY") }}</div>
                <div class="value">{{ infos.quantity }}</div>
            </div>
            <div class="data-point">
                <div class="label">{{ $t("QTYPROD") }}</div>
                <div class="value">{{ infos.prodQtd }}</div>
            </div>
            <div class="data-point">
                <div class="label">{{ $t("REFUSE") }}</div>
                <div class="value">{{ infos.refuse }}</div>
            </div>
            <div class="data-point">
                <div class="label">{{ $t("QTYGOOD") }}</div>
                <div class="value">{{ infos.goodQtd }}</div>
            </div>
            <div class="data-point">
                <div class="label">{{ $t("REWORK") }}</div>
                <div class="value">{{ infos.rework }}</div>
            </div>
            <div class="data-point">
                <div class="label">{{ $t("Quality") }}</div>
                <div class="value">{{ infos.quality }}%</div>
            </div>
        </div>
    </div>
</template>

<script>
import SysTooltip from "@/@core/components/sys-tooltip";
export default {
    components: {
        SysTooltip,
        InfoIcon: () => import("@core/assets/icons/info-outline.svg"),
        ShowDetailsIcon: () => import("@core/assets/icons/show-details-icon.svg"),
        UrlIcon: () => import("@core/assets/icons/url-icon.svg")
    },
    props: {
        infos: {
            type: Object,
            default: () => ({
                prod: 0,
                perf: 0,
                quality: 0,
                quantity: 0,
                prodQtd: 0,
                refuse: 0,
                goodQtd: 0,
                rework: 0
            })
        }
    },
    computed: {}
};
</script>

<style lang="scss">
.activity-card__info {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-radius: 16px;
    border: 1px solid #cfc4be;
    background: #fff;
    height: auto;
    overflow: hidden;

    &.banner-mode {
        .title-block {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 8px;
            padding: 6px 16px;
            background: #fafafa;
            border-bottom: 1px solid #cfc4be;

            .title {
                display: flex;
                align-items: center;
                gap: 8px;
                color: #4c4541;
                font-size: clamp(12px, 1vw + 2px, 14px);
                font-weight: 600;

                svg {
                    width: 18px;
                    height: 18px;
                }
            }

            .attachments-button {
                display: inline-flex;
                align-items: center;
                padding: 4px;
                border: 0;
                background: transparent;
                color: #974900;
                &:hover { background: #fff3e8; }
            }
            .icons-container {
                display: flex;
                align-items: center;
                gap: 12px;

                .show-details-icon {
                    cursor: pointer;
                    display: flex;
                    align-items: center;

                    svg {
                        width: 18px;
                        height: 18px;
                        fill: #998f8a;
                        path { fill: #998f8a; }
                    }

                    &:hover svg {
                        fill: #4c4541;
                        path { fill: #4c4541; }
                    }
                }

                #tooltip-links svg {
                    fill: #974900;
                    path { fill: #974900; }
                }
            }
        }

        .info-block {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-evenly;
            align-items: center;
            gap: 12px;
            padding: 8px 16px;

            .data-point {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                flex: 1 1 auto;
                min-width: 60px;
                text-align: center;

                .label {
                    color: #998f8a;
                    font-size: clamp(10px, 0.8vw + 2px, 11px);
                    font-weight: 500;
                    text-transform: uppercase;
                    margin-bottom: 2px;
                }

                .value {
                    color: #4c4541;
                    font-size: clamp(12px, 1vw + 4px, 16px);
                    font-weight: 600;
                }
            }
        }
    }
}

@media (min-width: 481px) and (max-width: 1024px) {
    .activity-card__info.banner-mode {
        .info-block {
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            align-items: stretch;
            column-gap: 16px;
            row-gap: 12px;

            .data-point {
                width: 100%;
                min-width: 0;
            }
        }
    }
}

@media (max-width: 480px) {
    .activity-card__info.banner-mode {
        .info-block {
            padding: 8px 12px;
            gap: 8px;

            .data-point {
                min-width: 20%;
                
                .label {
                    font-size: 10px;
                }

                .value {
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
